import * as React from 'react';
import Badge from '@cloudscape-design/components/badge';
import { useAlertCount } from './useAlertCount';

/**
 * Badge ao lado do item "Alertas" no menu lateral. Some quando count == 0;
 * vermelho com count quando >0.
 */
export function AlertCountBadge(): React.JSX.Element | null {
  const count = useAlertCount();
  if (count === 0) return null;
  return <Badge color="red">{count > 99 ? '99+' : count}</Badge>;
}
